import script from "./PageActions.vue?vue&type=script&setup=true&lang=js"
export * from "./PageActions.vue?vue&type=script&setup=true&lang=js"

import "./PageActions.vue?vue&type=style&index=0&id=5389e9a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5389e9a4"]])

export default __exports__